import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { Option } from '../Select/Select';
import { useAllCountriesListQuery } from '../../../services/countries';

type CountryFilterSelectProps = {
  defaultCountry?: number;
  onChange: (countryId: number | undefined) => void;
  disabled?: boolean;
  className?: string;
};

const CountryFilterSelect: React.FC<CountryFilterSelectProps> = ({ defaultCountry, onChange, disabled, className }) => {
  const { t } = useTranslation();
  const { data, isFetching } = useAllCountriesListQuery();

  const options: Option[] = useMemo(
    () => (data || []).map(country => ({ value: String(country.id), label: country.name ?? '' })),
    [data],
  );

  const selected = useMemo(
    () => options.find(option => option.value === String(defaultCountry)),
    [options, defaultCountry],
  );

  return (
    !isFetching && (
      <Select
        options={options}
        defaultValue={selected}
        onChange={option => {
          const id = option ? parseInt(option.value, 10) : NaN;
          onChange(Number.isNaN(id) ? undefined : id);
        }}
        placeholder={t('general.select')}
        disabled={disabled}
        className={className}
        isSearchable
        isClearable
      />
    )
  );
};

export default CountryFilterSelect;
